import { render, staticRenderFns } from "./BowContentMediaDx.vue?vue&type=template&id=4e5048e2&"
import script from "./BowContentMediaDx.vue?vue&type=script&lang=js&"
export * from "./BowContentMediaDx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BowContentMedia: require('/workspace/components/organisms/BowContentMedia/BowContentMedia.vue').default})
